module.exports = "/_next/static/images/advance-logo-white-5cd44655e4bf950ceb4d8d8a535e782a.png";